import React from 'react';

const UserMarksStatsOverview = React.memo(({
    stats,
    quickTab = 'ALL',
    onSelectQuickTab,
    t
}) => {
    const {
        totalLessons = 0,
        totalAttempts = 0,
        avgScoreRate = 0,
        bestScore = 0,
        masteredCount = 0,
        formattedTotalTime = '00:00'
    } = stats || {};

    const isMasteredActive = quickTab === 'MASTERED';

    return (
        <div className="lr-kpi-grid mb-4 anim-fade-up">
            {/* 1. Total Lessons & Attempts */}
            <div className="lr-kpi-card kpi-card--tasks shadow-sm">
                <div className="lr-kpi-header">
                    <span className="lr-kpi-title">
                        <span className="kpi-icon-wrap kpi-icon--indigo">
                            <i className="fas fa-book-reader"></i>
                        </span>
                        <span>{t('Pages.Lessons.TotalLessons') || 'إجمالي الدروس والمحاولات'}</span>
                    </span>
                    <span className="lr-kpi-value" style={{ color: '#4f46e5' }}>
                        {totalLessons}
                    </span>
                </div>
                <div className="lr-kpi-sub">
                    <span>{totalAttempts} {t('Pages.Lessons.Attempts') || 'محاولة منجزة'}</span>
                    <span className="font-weight-bold text-primary">{totalLessons} {t('Pages.Lessons.DistinctLessons') || 'درساً فريداً'}</span>
                </div>
            </div>

            {/* 2. Average Score Rate */}
            <div className="lr-kpi-card kpi-card--marks shadow-sm">
                <div className="lr-kpi-header">
                    <span className="lr-kpi-title">
                        <span className="kpi-icon-wrap kpi-icon--amber">
                            <i className="fas fa-chart-line"></i>
                        </span>
                        <span>{t('Pages.Lessons.AverageScore') || 'معدل الدرجات العام'}</span>
                    </span>
                    <span className="lr-kpi-value" style={{ color: avgScoreRate >= 80 ? '#16a34a' : avgScoreRate >= 60 ? '#f59e0b' : '#ef4444' }}>
                        %{avgScoreRate}
                    </span>
                </div>
                <div className="lr-kpi-bar">
                    <div
                        className="lr-kpi-bar-fill"
                        style={{
                            width: `${Math.min(100, Math.max(0, avgScoreRate))}%`,
                            background: avgScoreRate >= 80 ? '#16a34a' : avgScoreRate >= 60 ? '#f59e0b' : '#ef4444'
                        }}
                    />
                </div>
                <div className="lr-kpi-sub">
                    <span>{t('Pages.Lessons.MasteryLevel') || 'مستوى الإتقان'}</span>
                    <span className="font-weight-bold" style={{ color: avgScoreRate >= 80 ? '#16a34a' : avgScoreRate >= 60 ? '#f59e0b' : '#ef4444' }}>
                        {avgScoreRate >= 90 ? (t('Pages.Lessons.ScoreExcellent') || 'ممتاز') : avgScoreRate >= 75 ? (t('Pages.Lessons.ScoreVeryGood') || 'جيد جداً') : avgScoreRate >= 60 ? (t('Pages.Lessons.ScoreGood') || 'متوسط') : (t('Pages.Lessons.ScoreNeedsImprovement') || 'بحاجة لتحسين')}
                    </span>
                </div>
            </div>

            {/* 3. Mastered Lessons KPI (Clickable filter) */}
            <div
                className={`lr-kpi-card kpi-card--pct shadow-sm ${isMasteredActive ? 'border-success' : ''}`}
                onClick={() => onSelectQuickTab && onSelectQuickTab(isMasteredActive ? 'ALL' : 'MASTERED')}
                style={{
                    cursor: onSelectQuickTab ? 'pointer' : 'default',
                    transition: 'all 0.2s ease',
                    boxShadow: isMasteredActive ? '0 0 0 2px #16a34a' : undefined
                }}
                title={isMasteredActive ? (t('Pages.Lessons.CancelMasteredFilter') || 'إلغاء تصفية الدروس المتقنة') : (t('Pages.Lessons.ClickToFilterMastered') || 'انقر لتصفية الدروس المتقنة بنسبة 80% فأعلى')}
            >
                <div className="lr-kpi-header">
                    <span className="lr-kpi-title">
                        <span className="kpi-icon-wrap" style={{ backgroundColor: '#dcfce7', color: '#16a34a' }}>
                            <i className="fas fa-check-circle"></i>
                        </span>
                        <span>{t('Pages.Lessons.MasteredLessons') || 'الدروس المتقنة (≥80%)'}</span>
                    </span>
                    <span className="lr-kpi-value" style={{ color: '#16a34a' }}>
                        {masteredCount}
                    </span>
                </div>
                <div className="lr-kpi-sub">
                    <span>{isMasteredActive ? (t('Pages.Lessons.FilterActive') || 'تصفية نشطة') : (t('Pages.Lessons.ClickToFilter') || 'انقر للتصفية')}</span>
                    <span className={`status-chip ${isMasteredActive ? 'success font-weight-bold' : 'success'} py-0 px-2`}>
                        {masteredCount} {t('Pages.Lessons.Lessons') || 'دروس متقنة'}
                    </span>
                </div>
            </div>

            {/* 4. Total Practice Time & Top Score */}
            <div className="lr-kpi-card kpi-card--time shadow-sm">
                <div className="lr-kpi-header">
                    <span className="lr-kpi-title">
                        <span className="kpi-icon-wrap kpi-icon--sky">
                            <i className="fas fa-user-clock"></i>
                        </span>
                        <span>{t('Pages.Lessons.PracticeTime') || 'وقت التدرب المنجز'}</span>
                    </span>
                    <span className="lr-kpi-value" style={{ color: '#0284c7', fontSize: '1.25rem' }}>
                        {formattedTotalTime}
                    </span>
                </div>
                <div className="lr-kpi-sub">
                    <span>{t('Pages.Lessons.HighestScore') || 'أعلى نسبة محرزة'}</span>
                    <span className="font-weight-bold text-success">
                        <i className="fas fa-trophy ml-1 text-warning"></i>
                        %{bestScore}
                    </span>
                </div>
            </div>
        </div>
    );
});

export default UserMarksStatsOverview;
